<template>
    <div>{{ remained }}</div>
</template>

<script>
import dayjs from "dayjs";
export default {
    props: ["work"],
    data: () => ({
        remained: null,
        interval: null,
    }),
    computed: {
        endsAt() {
            return this.work?.duration_auction?.endsAt || this.work?.program?.duration?.endsAt;
        },
    },
    mounted() {
        this.interval = setInterval(this.setRemained, 1000);
    },
    destroyed() {
        if (this.interval !== null) {
            clearInterval(this.interval);
            this.interval = null;
        }
    },
    methods: {
        setRemained() {
            const now = dayjs();
            const endsAt = dayjs(this.endsAt);

            const diff = endsAt.diff(now, "day", true);
            if (diff < 0) {
                this.remained = "0일 0시 0분 0초";
                return;
            }

            const d = Math.floor(diff);
            const h = Math.floor((diff - d) * 24);
            const m = Math.floor(((diff - d) * 24 - h) * 60);
            const s = Math.floor((((diff - d) * 24 - h) * 60 - m) * 60);

            this.remained = `${d}일 ${h}시 ${m}분 ${s}초`;
        },
    },
};
</script>

<style></style>
